"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var underscore_1 = __importDefault(require("underscore"));
var AccordionController_1 = require("../components/AccordionController");
var ExpandTextController_1 = require("../components/ExpandTextController");
var BannerController_1 = require("../components/BannerController");
var cookie_1 = __importDefault(require("../components/cookie"));
var common_1 = __importDefault(require("../components/common"));
var header_features_1 = __importDefault(require("../components/header-features"));
var scroller_1 = require("../components/galleries/scroller");
var gallery_1 = __importDefault(require("../components/gallery"));
var popup_1 = __importDefault(require("../components/popups/popup"));
var more_details_popup_1 = __importDefault(require("../components/popups/more-details-popup"));
var smooth_scrolling_1 = __importDefault(require("../components/smooth-scrolling"));
var TrackingTypes_1 = require("../helpers/TrackingTypes");
var GA4SocialNetworkTracker_1 = require("../components/GA4/GA4SocialNetworkTracker");
var index_1 = require("../components/banners/index");
var ExpandBannerController_1 = require("../components/ExpandBannerController");
var StaticPage = /** @class */ (function () {
    function StaticPage() {
        new common_1.default({
            trackingCategory: TrackingTypes_1.TrackingData.FURY_STATIC_PAGE,
        }); // Common should be first because it contains error-logger
        (0, index_1.initBanners)('StaticPage');
        new header_features_1.default({
            trackingCategory: TrackingTypes_1.TrackingData.FURY_STATIC_PAGE,
        });
        new GA4SocialNetworkTracker_1.GA4SocialNetworkTracker();
        if (jQuery('#localization-modal').length) {
            var localizationPopup = new popup_1.default({
                popup: '#localization-modal',
                closeBtn: '.modal-window .close-btn, .modal-window .stay-on-page',
            }).init();
            localizationPopup.attachCloseEvent();
        }
        underscore_1.default.each(jQuery('.slider-holder'), function (item) {
            return new gallery_1.default({
                holder: item,
                trackingCategory: TrackingTypes_1.TrackingData.FURY_STATIC_PAGE,
            });
        });
        underscore_1.default.each(jQuery('.reviews-slider-holder'), function (item) {
            return new gallery_1.default({
                holder: item,
                trackingCategory: TrackingTypes_1.TrackingData.FURY_STATIC_PAGE,
                duration: 0,
            });
        });
        underscore_1.default.each(jQuery(AccordionController_1.AccordionController.accordionQuerySelector), function (item) { return new AccordionController_1.AccordionController(item); });
        underscore_1.default.each(jQuery(ExpandTextController_1.ExpandTextController.buttonRowQuerySelector), function (item) { return new ExpandTextController_1.ExpandTextController(item); });
        underscore_1.default.each(jQuery(ExpandBannerController_1.ExpandBannerController.buttonRowQuerySelector), function (item) { return new ExpandBannerController_1.ExpandBannerController(item); });
        new BannerController_1.BannerController(TrackingTypes_1.TrackingData.FURY_STATIC_PAGE);
        new more_details_popup_1.default({ trackingCategory: TrackingTypes_1.TrackingData.FURY_STATIC_PAGE });
        new cookie_1.default();
        new smooth_scrolling_1.default();
        this.instantiateScrollers();
    }
    StaticPage.prototype.instantiateScrollers = function () {
        var scrollers = document.querySelectorAll('.js-products-scroller, .js-styles-scroller, .js-trends-scroller');
        for (var i = 0; i < scrollers.length; i++) {
            var buttonStateIsHidden = scrollers[i].classList.contains('js-styles-scroller') ||
                scrollers[i].classList.contains('js-trends-scroller');
            new scroller_1.Scroller(scrollers[i], {
                classes: {
                    viewport: '.js-viewport',
                    slide: '.js-slide',
                    prevButton: '.js-prev-button',
                    nextButton: '.js-next-button',
                },
                buttonState: buttonStateIsHidden ? 'is-hidden' : 'is-disabled',
                trackingCategory: TrackingTypes_1.TrackingData.FURY_STATIC_PAGE,
            });
        }
    };
    return StaticPage;
}());
new StaticPage();
